app.service('checkSameDayMessage', function (loading, modal) {

	function check(sameDayMessage, callback, next) {

		function changePaymentTypeForSameDayDeliveryType() {
			callback();
			loading.start();
			$.ajax({
				url: '/order-path-change-payment-type.ltr',
				dataType: 'json',
				type: 'POST',
				data: {
					refresh: true
				},
				success: function () {
					loading.stop();
					next();
				},
				error: function () {
					modal.alert('Błąd zmiany typy płatności', function () {
						loading.reload({ soft: true });
					});
				}
			});
		}

		if (sameDayMessage) {
			modal.generate({
				content: sameDayMessage,
				buttons: [
					{
						text: 'Wybieram inny termin dostawy',
						cssClass: 'btn-third js-close-modal'
					}, {
						text: 'Zapłacę przy odbiorze',
						cssClass: 'btn-primary js-close-modal',
						click: function () {
							changePaymentTypeForSameDayDeliveryType();
						}
					}
				]
			});
			return true;
		}
		return false;
	}

	return {
		check
	};
});
